module.exports = __webpack_public_path__ + "img/ESPN2-heatmap.c67d7ac0.png";